import { orchestrator } from 'satcheljs';
import { getDateString, isSameDay } from 'owa-datetime';
import { setDueDate } from '../actions';
import patchAsset from '../utils/patchAsset';

orchestrator(setDueDate, ({ projectId, assetId, dueDate, oldDueDate, shouldRemoveTask }) => {
    const newDateStr = !!dueDate ? getDateString(dueDate) : '';
    const newDateTz = dueDate?.tz ?? '';
    patchAsset(
        projectId,
        assetId,
        {
            dueDate: newDateStr,
            dueDateTz: newDateTz,
            // if due date is removed, set isComplete to false and remove task reference if specified
            ...(!dueDate && { isComplete: false, ...(shouldRemoveTask && { taskId: '' }) }),
        },
        { dueDate: oldDueDate },
        () => {
            if (dueDate && oldDueDate) {
                return !isSameDay(dueDate, oldDueDate);
            } else if (!oldDueDate) {
                // VSO 109660: avoid a patch when setting a new date to let task sync assign due date (see setTaskIdOrchestrator.ts)
                return false;
            }

            return true;
        }
    );
});
